/** @file BONE_SHAPE: the wire bone's proportions (Blender-style octahedron) and the joint and root rings. */

/**
 * `ringAt`: the widest ring at this fraction of the length from the head; half-width `widthShare` of the length within
 * `widthMin`..`widthMax` CSS px; `edges`: the 12 wire edges as vertex pairs (0 head, 1..4 the ring, 5 the tail);
 * `line` / `boldLine`: wire widths in CSS px; `joint`: the screen-facing head circle's radius and segments; `root`:
 * the entity origin's ground ring.
 */
export const BONE_SHAPE = {
  ringAt: 0.15, widthShare: 0.08, widthMin: 2, widthMax: 7, line: 1, boldLine: 1.5,
  edges: [[0, 1], [0, 2], [0, 3], [0, 4], [1, 2], [2, 3], [3, 4], [4, 1], [1, 5], [2, 5], [3, 5], [4, 5]],
  joint: { radius: 4, segments: 16 }, root: { radius: 8, segments: 24 },
} as const;
